import i18next from 'i18next'
import i18nextLocizeBackend from 'i18next-locize-backend'
import LanguageDetector from 'i18next-browser-languagedetector'

const locizeOptions = {
  projectId: 'fe66de9c-5e32-4952-ac54-d951aed61b9b',
  referenceLng: 'en'
}

i18next.use(i18nextLocizeBackend).use(LanguageDetector)

const i18nextOptions = {
  debug: false,
  initImmediate: false,
  fallbackLng: 'en',
  ns: ['language', 'acquirers', 'admin', 'device', 'footer', 'general', 'header', 'invoicing-email', 'login', 'map', 'okta', 'online-card', 'orders', 'reset-ask', 'reset-confirm', 'settlements'],
  defaultNS: 'login',
  backend: locizeOptions,
  useCookie: true,
  useLocalStorage: false,
  react: { useSuspense: false }
}

window.i18next = i18next

export default i18nextOptions
